<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    d="M13 1C14.1046 1 15 1.89543 15 3L15 13C15 14.0357 14.2128 14.887 13.2041 14.9893L13 15L3 15L2.7959 14.9893C1.85435 14.8938 1.1062 14.1457 1.01074 13.2041L1 13L1 3C1 1.89543 1.89543 1 3 1L13 1ZM3 13L8 13L8 9C8 8.44772 8.44772 8 9 8L13 8L13 3L3 3L3 13Z"
    fill="#868D9C"
  />
</template>
